import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useProjectCostSummary = (projectId, config = {}) => {
  return useQuery({
    ...config,
    queryKey: ["project-cost-summary", projectId],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/projects/${projectId}/budget`,
        signal,
      });
    },
  });
};

export const useTaskCostSummary = (projectId, taskId, config = {}) => {
  return useQuery({
    ...config,
    queryKey: ["task-cost-summary", projectId, taskId],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/budget`,
        signal,
      });
    },
  });
};
